import { v4 as uuidv4 } from "uuid";

import type { UUIDGenerator } from "../../../shared/core/uuid/uuid-generator";

export class WebUUIDGenerator implements UUIDGenerator {
  async getRandomUUID(): Promise<string> {
    return uuidv4();
  }
}
